import { useState, useCallback, useEffect } from 'react';
import { DataViewError, DataViewLoading, DataViewMessageProps, DataViewNoData } from '../components/data-view-message/DataViewMessage';

// startLoading(), loadingComplete(), loadingError(), isLoading, dataViewMessageData
export type UseLoadingStateResult = [
    (loader?: string) => void,
    (loader?: string) => void,
    (error: string, loader?: string) => void,
    boolean,
    DataViewMessageProps | undefined
];

export default function useLoadingState(): UseLoadingStateResult {
    const [loaders, setLoaders] = useState<string[]>([]);
    const [error, setError] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [dataViewMessageData, setDataViewMessageData] = useState<DataViewMessageProps | undefined>(undefined);

    const updateState = useCallback(() => {
        const loading = loaders.length > 0;
        setIsLoading(loading);

        if (loading) {
            setDataViewMessageData(DataViewLoading);
        }
        else if (error) {
            setDataViewMessageData({ ...DataViewError, message: error });
        } else {
            setDataViewMessageData(undefined);
        }

    }, [loaders, error]);

    useEffect(() => {
        updateState();
    }, [updateState]);

    const startLoading = useCallback((loader: string = 'x') => {
        setLoaders((l) => {
            if (l.find(x => x === loader))
                return l;

            l.push(loader);
            return [...l];
        });
    }, []);

    const loadingComplete = useCallback((loader: string = 'x') => {
        setLoaders((l) => {
            if (!l.find(x => x === loader))
                return l;

            l = l.filter(x => x !== loader);
            return [...l];
        });

        setError(undefined);
    }, []);

    const loadingError = useCallback((error: string, loader: string = 'x') => {
        setLoaders((l) => {
            if (!l.find(x => x === loader))
                return l;

            l = l.filter(x => x !== loader);
            return l;
        });

        setError(error);
    }, []);

    return [startLoading, loadingComplete, loadingError, isLoading, dataViewMessageData];
}
